<template>
    <div class="container">
      <NavMenu class="nav_menu"></NavMenu>
  
      <div class="main-container">
        <el-tabs v-model="activeTab" type="card">
          <!-- 被举报帖子 -->
          <el-tab-pane label="被举报帖子" name="post">
            <el-table
              :data="currentPostData"
              style="width: 100%"
              v-loading="loading">
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="title" label="帖子标题" width="200"></el-table-column>
              <el-table-column prop="content" label="帖子内容" show-overflow-tooltip></el-table-column>
              <el-table-column prop="reason" label="举报原因" width="150"></el-table-column>
              <el-table-column label="状态" width="120">
                <template slot-scope="">
                  <el-tag type="warning">待审核</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="success"
                    @click="handleAudit(scope.row, 'post', 'approve')">通过</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleAudit(scope.row, 'post', 'reject')">驳回</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleView(scope.row, 'post')">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination-container"
              @size-change="handlePostSizeChange"
              @current-change="handlePostCurrentChange"
              :current-page="postPagination.currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="postPagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="postPagination.total">
            </el-pagination>
          </el-tab-pane>
  
          <!-- 被举报评论 -->
          <el-tab-pane label="被举报评论" name="comment">
            <el-table
              :data="currentCommentData"
              style="width: 100%"
              v-loading="loading">
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="content" label="评论内容" show-overflow-tooltip></el-table-column>
              <el-table-column prop="relatedPost" label="所属帖子" width="200"></el-table-column>
              <el-table-column prop="reason" label="举报原因" width="150"></el-table-column>
              <el-table-column label="状态" width="120">
                <template slot-scope="">
                  <el-tag type="warning">待审核</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="success"
                    @click="handleAudit(scope.row, 'comment', 'approve')">通过</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleAudit(scope.row, 'comment', 'reject')">驳回</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleView(scope.row, 'comment')">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination-container"
              @size-change="handleCommentSizeChange"
              @current-change="handleCommentCurrentChange"
              :current-page="commentPagination.currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="commentPagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="commentPagination.total">
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
  
        <!-- 查看详情对话框 -->
        <el-dialog :title="detailTitle" :visible.sync="viewDialogVisible" width="700px">
          <div v-if="currentItem.type === 'post'">
            <h3 class="detail-title">{{ currentItem.title }}</h3>
            <div class="detail-content">{{ currentItem.content }}</div>
            <div class="image-list" v-if="currentItem.images && currentItem.images.length">
              <el-image 
                v-for="(img, index) in currentItem.images" 
                :key="index"
                :src="img"
                fit="cover"
                class="detail-image"
                :preview-src-list="currentItem.images">
              </el-image>
            </div>
            <div class="detail-meta">
              <span>举报原因：{{ currentItem.reason }}</span>
            </div>
          </div>
  
          <div v-if="currentItem.type === 'comment'">
            <div class="comment-content">{{ currentItem.content }}</div>
            <div class="detail-meta">
              <p>所属帖子：{{ currentItem.relatedPost }}</p>
              <p>举报原因：{{ currentItem.reason }}</p>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </template>
  
  <script>
  import NavMenu from '@/components/NavMenu.vue';
  
  export default {
    components: { NavMenu },
    data() {
      return {
        activeTab: 'post',
        loading: false,
        viewDialogVisible: false,
        currentItem: {},
        // 分页配置
        postPagination: {
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        commentPagination: {
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        // 模拟数据
        postReports: [
          {
            id: 1,
            type: 'post',
            title: '测试帖子标题1',
            content: '这是被举报的帖子内容...',
            reason: '包含不当信息',
            relatedPost: '-',
            images: [
              'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
              'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'
            ]
          },
          {
            id: 2,
            type: 'post',
            title: '测试帖子标题2',
            content: '这是另一个被举报的帖子内容...',
            reason: '虚假信息',
            relatedPost: '-',
            images: []
          }
        ],
        commentReports: [
          {
            id: 1,
            type: 'comment',
            content: '这是被举报的评论内容...',
            reason: '人身攻击',
            relatedPost: '测试帖子标题1'
          }
        ]
      }
    },
    computed: {
      currentPostData() {
        const start = (this.postPagination.currentPage - 1) * this.postPagination.pageSize;
        return this.postReports.slice(start, start + this.postPagination.pageSize);
      },
      currentCommentData() {
        const start = (this.commentPagination.currentPage - 1) * this.commentPagination.pageSize;
        return this.commentReports.slice(start, start + this.commentPagination.pageSize);
      },
      detailTitle() {
        return this.currentItem.type === 'post' 
          ? '被举报帖子详情' 
          : '被举报评论详情'
      }
    },
    mounted() {
      // 初始化分页总数
      this.postPagination.total = this.postReports.length;
      this.commentPagination.total = this.commentReports.length;
    },
    methods: {
      // 处理审核
      handleAudit(item, type, action) {
        const actionMap = {
          approve: '通过',
          reject: '驳回'
        }
        
        this.$confirm(`确定要${actionMap[action]}该${type === 'post' ? '帖子' : '评论'}吗？`, '提示', {
          type: 'warning'
        }).then(() => {
          const targetArray = type === 'post' 
            ? this.postReports 
            : this.commentReports
          
          const index = targetArray.findIndex(i => i.id === item.id);
          if (index !== -1) {
            targetArray.splice(index, 1)
            this.$message.success(`已成功${actionMap[action]}`)
            // 更新分页总数
            if (type === 'post') {
              this.postPagination.total = this.postReports.length;
            } else {
              this.commentPagination.total = this.commentReports.length;
            }
          }
        }).catch(() => {})
      },
  
      // 查看详情
      handleView(item, type) {
        this.currentItem = { ...item }
        this.viewDialogVisible = true
      },
  
      // 分页处理方法
      handlePostSizeChange(newSize) {
        this.postPagination.pageSize = newSize;
        this.postPagination.currentPage = 1;
      },
      handlePostCurrentChange(newPage) {
        this.postPagination.currentPage = newPage;
      },
      handleCommentSizeChange(newSize) {
        this.commentPagination.pageSize = newSize;
        this.commentPagination.currentPage = 1;
      },
      handleCommentCurrentChange(newPage) {
        this.commentPagination.currentPage = newPage;
      }
    }
  }
  </script>
  
  <style scoped>
  .container {
    display: flex;
    height: 100vh;
  }
  
  .nav_menu {
    width: 280px !important; /* 覆盖全局样式 */
    flex: 0 0 auto !important; /* 禁止 NavMenu 伸缩 */
    min-width: 280px !important; /* 确保最小宽度 */
    position: static !important; /* 重置布局属性 */
  }
  
  .container ::v-deep .nav-menu {
    width: 280px !important;
    min-width: 280px !important;
  }
  .main-container {
    flex: 1;
    padding: 20px;
    overflow: auto;
  }
  
  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
  
  .detail-title {
    color: #303133;
    margin-bottom: 15px;
  }
  
  .detail-content {
    color: #606266;
    line-height: 1.6;
    margin-bottom: 20px;
  }
  
  .detail-meta {
    color: #909399;
    margin-top: 15px;
  }
  
  .image-list {
    margin: 15px 0;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .detail-image {
    width: 200px;
    height: 200px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,.12);
    cursor: pointer;
  }
  
  ::v-deep .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }
  </style>